module.exports = __webpack_public_path__ + "img/11.be143691.jpg";